import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import {
  TiimePropertyDirective,
  TiimeLargePropertyDirective,
  FallbackTextDirective,
  TiimePropertiesDirective,
  TiimeIconPropertyDirective,
  TiimeIconModule
} from 'tiime-material';

import { ProspectAcquisitionChannel } from '@gi/enums/prospect-acquisition-channel.enum';
import { Prospect } from '@gi/models/prospect';
import { CodeAndLabel } from '@models/code-and-label';
import { AddressPropertyComponent } from '@shared-components/address-property/address-property.component';
import { CompanyPermanentNotePropertiesComponent } from '@shared-components/company-permanent-note-properties/company-permanent-note-properties.component';
import { TiimeBusinessProAccountIntentionIconComponent } from '@shared-components/tiime-business-pro-account-intention-icon/tiime-business-pro-account-intention-icon.component';
import { CodeAndLabelPipe } from '@shared-pipes/code-and-label/code-and-label.pipe';
import { PhonePipe } from '@shared-pipes/phone/phone.pipe';

@Component({
  selector: 'app-contract-prospect-container',
  standalone: true,
  imports: [
    CommonModule,
    TiimePropertyDirective,
    TiimeLargePropertyDirective,
    TiimeIconPropertyDirective,
    TiimeIconModule,
    FallbackTextDirective,
    AddressPropertyComponent,
    CompanyPermanentNotePropertiesComponent,
    PhonePipe,
    TiimeBusinessProAccountIntentionIconComponent,
    CodeAndLabelPipe
  ],
  templateUrl: './contract-prospect-container.component.html',
  styleUrls: ['./contract-prospect-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [TiimePropertiesDirective]
})
export class ContractProspectContainerComponent {
  @Input() prospect: Prospect;
  @Input() acquisitionChannels: CodeAndLabel<ProspectAcquisitionChannel>[];
}
